export const EXPERIENCES = [
    {
        role: "Full Stack Developer",
        company: "Aphex",
        duration: "December 2025 - Present",
        description: []
    },
    {
        role: "Full Stack Developer",
        company: "LX Group",
        duration: "July 2023 - May  2025",
        description: [
            "Turned design from Figma to responsive components and user interfaces using ReactJS with Redux and Material UI",
            "Implemented server-side logic using NodeJS with ExpressJS, integrate with AWS and other  third party services,  and creates and integrates API endpoints utilizing PostgreSQL",
            "Troubleshooted and fixed issues raised by the customer support team ensuring minimal impact on clients and business operations",
            "Collaborated with a global team of developers and  provides code reviews to ensure quality of the code base"
        ]
    },
    {
        role: "Full Stack Developer",
        company: "TAS Tradesoft Corporation",
        duration: "June 2021 - July 2023",
        description: [
            "Designed and developed new features on the payment facility system which involved payments processing, invoicing, and dashboard and reports creation using ReactJS and NodeJS",
            "Improved existing functionalities to enhance client’s user experience and strengthened overall security of the application by implementing permissions and authentications",
            "Worked closely with client and global team ensuring clear communication of tasks and project status"
        ]
    },
    {
        role: "Web Developer",
        company: "Trends and Technologies, Inc.",
        duration: "August 2018 - June 2021",
        description: [
            "Designed,  implemented, tested, and maintained several web applications & innovative solutions using various technologies (Javascript, NodeJS, Python, ReactJS) contributing to successful client deployments",
            "Integrated data from various service, network devices,  and databases through API integration reducing manual data entry time",
            "Provided onsite technical support for customers and closely worked with other technical teams",
            "Performed research and development for new software & technologies to assess operational feasibility"
        ]
    },
    {
        role: "BS Computer Science",
        company: "University of the Philippines",
        duration: "August 2014 - July 2018",
        description: [
            "Completed Bachelor of Science in Computer Science"
        ]
    },
];